import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import * as configService from '@/services/configService'
import _ from 'lodash'

Vue.use(Vuex)

const allDepartments = {
    uuid: 0,
    name: 'Virksomheden'
}

export default new Vuex.Store({
    state: {
        config: {
            companyMeta: {},
            availableAccountingYears: [],
            availableDepartments: [allDepartments],
            currentDepartment: allDepartments,
            startDate: 'Jan 1, 2019 00:00:00',
            endDate: new Date(),
            loaded: false
        },
        view: 'drift',
        efficiencyData: {},
        closedRows: [],
        customerRevenueRows: [],
        // graphColors: ['#F44336', /* '#E91E63', */ '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#FFC107', '#FF9800', '#FF5722', '#795548', '#607D8B'],
        // graphColors: ['#A80000', '#9D0017', '#500064', '#1B006B', '#000569', '#004AA7', '#005DA8', '#007088', '#004A3C', '#006304', '#3F7700', '#B37500', '#B34C00', '#B30B00', '#2D0900', '#14313F']
        // graphColors: ['#e6194B', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#42d4f4', '#f032e6', '#fabed4', '#469990', '#dcbeff', '#9A6324', '#fffac8', '#800000', '#aaffc3', '#000075', '#a9a9a9', '#ffffff', '#000000']
        // graphColors: ['#377169', '#bcac4a', '#ffb963', '#02bec4', '#690d0d', '#0285a8', '#400d2a', '#8dbda9', '#c38f5f', '#3f5866', '#140a25']
        graphColors: ['#1e807c', '#7aa8d4', '#c53e4a', '#e8c531', '#91c891', '#246ab2', '#7a215c', '#e75645', '#c8a146', '#cccccc', '#000000']
    },
    getters: {
        groupedProjects: state => {
            if (state.closedRows.length) {
                return _.groupBy(state.closedRows, project => {
                    return project.type ? project.type.name : 'Ingen type'
                })
            }
            return null
        },
        getStartDate: state => {
            return moment(state.config.startDate).format('YYYY-MM-DD')
        },
        getEndDate: state => {
            return moment(state.config.endDate).format('YYYY-MM-DD')
        },
        getAvailableDepartments: state => {
            return state.config.availableDepartments
        },
        getCurrentDepartment: state => {
            return state.config.currentDepartment
        },
        getCurrentAccountingYear: state => {
            return state.config.availableAccountingYears[0]
        }
    },
    actions: {
        getConfig (context) {
            configService.get({}, response => {
                context.commit('setConfig', response.data)
                context.dispatch('setDatesPreset', 'currentAccountingYear')
            })
        },
        setDatesPreset: (context, preset) => {
            const date = new Date()
            let startDate = null; let endDate = null
            switch (preset) {
                case 'currentAccountingYear':
                    startDate = context.state.config.availableAccountingYears[0].from_date
                    endDate = context.state.config.availableAccountingYears[0].to_date
                    break
                case 'currentWeek':
                    const first = date.getDate() - date.getDay() + 1
                    const last = first + 6
                    startDate = new Date(date.setDate(first))
                    endDate = new Date(date.setDate(last))
                    break
                case 'currentMonth':
                    startDate = new Date(date.getFullYear(), date.getMonth(), 1)
                    endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
                    break
                default:
                    console.log('fejl i setDatesPreset: ' + preset + ' eksisterer ikke')
            }
            context.commit('setDates', {startDate: startDate, endDate: endDate})
        }
    },
    mutations: {
        setCurrentDepartment: (state, department) => {
            state.config.currentDepartment = department
        },
        resetCurrentDepartment: state => {
            state.config.currentDepartment = allDepartments
        },
        setConfig: (state, config) => {
            state.config.lastSynced = config.last_sync
            state.config.availableAccountingYears = config.accounting_years.reverse()
            state.config.availableDepartments = [allDepartments, ...config.departments]
            state.config.companyMeta = config.company
            state.config.loaded = true
        },
        setDates: (state, dates) => {
            state.config.startDate = dates.startDate
            state.config.endDate = dates.endDate
        },
        setClosedRows: (state, rows) => {
            state.closedRows = rows
        },
        setCustomerRevenueRows: (state, rows) => {
            state.customerRevenueRows = rows
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js